import React from 'react'
import { Link } from 'react-router-dom'
import * as ROUTES from '../../constants/routes'
import { Grid, Button, Paper, TextField, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send'
import AWS from 'aws-sdk'

class ContactUs extends React.Component {

    state = {
        name: '',
        email: '',
        type: '',
        description: '',
        sent: false,
    }

    componentWillMount() {
        window.scrollTo(0, 0)
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleSend = event => {

        event.preventDefault()

        const { name, email, type, description } = this.state

        const emailParams = {
            Destination: {
                BccAddresses: [],
                CcAddresses: [],
                ToAddresses: ['Asif Hazrat <asifhazrat@gmail.com>'],
            },
            Message: {
                Body: {
                    Html: {
                        Charset: 'UTF-8',
                        Data: ` <div style='text-align: center; background-color: #ddd; padding: 20px; border-radius: 5px;'> <div style='max-width: 400px; border-radius: 5px; padding: 40px; background-color: #fff; margin: auto; color: black;'> <h1>New Message from ${name}</h1> <h3>Type: ${type}</h3> <p>Hi Asif!</p> <p>${description}</p> <p style='font-size: 0.8em;'>${name} can be reached at <a href='mailto:${email}'>${email}</a></p> </div> </div> `
                    },
                    Text: {
                        Charset: 'UTF-8',
                        Data: ` New ${type} Contact from ${name}. \n\n ${description} \n\n ${name} can be reched at ${email}. `
                    }
                },
                Subject: {
                    Charset: 'UTF-8',
                    Data: `FractalStrategies.com: New Message from ${name}`
                }
            },
            Source: 'Contact Us <ContactUs@fractalstrategies.com>',
            ReplyToAddresses: ['Fractal Strategies <fractalstrategies@gmail.com>']
        }

        const creds = new AWS.Credentials({ accessKeyId: 'AKIAJR5XJEE2QFMWHT3A', secretAccessKey: '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' })
        AWS.config.update({ region: 'us-east-1', credentials: creds })
        var ses = new AWS.SES()
        ses.sendEmail(emailParams, (err, data) => {
            if (err) console.log(err, err.stack)
            else return
        })

        this.setState({ sent: true })

    }

    render() {

        const { name, email, type, description } = this.state

        const isInvalid = name === '' ||
            email === '' ||
            email.indexOf('@') < 1 ||
            email.indexOf('.') < 4 ||
            email.length < email.indexOf('.') + 3 ||
            type === '' ||
            description === ''

        const buttons = (
            <Grid container spacing={16} justify='center'>
                <Grid item xs={2}>
                    <Button variant='contained' color='primary' component={Link} to={ROUTES.HOME}>
                        back
                    </Button>
                </Grid>
                <Grid item xs={2}>
                    <Button variant='contained' color='primary' component={Link} to={ROUTES.PRICING}>
                        pricing
                    </Button>
                </Grid>
            </Grid>
        )

        const contactUsForm = (
            <form>
                <Grid container spacing={24} direction='column'>
                    <Grid item>
                        <TextField
                            name='name'
                            label='Name'
                            style={{ minWidth: '250px' }}
                            onChange={this.onChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            name='email'
                            label='Email'
                            style={{ minWidth: '250px' }}
                            onChange={this.onChange}
                        />
                    </Grid>
                    <Grid item>
                        <FormControl>
                            <InputLabel>Project Type</InputLabel>
                            <Select
                                name='type'
                                value={this.state.type}
                                style={{ minWidth: '250px', textAlign: 'left' }}
                                onChange={this.onChange}
                            >
                                <MenuItem value='Product: Basic Web'>Product: Basic Web</MenuItem>
                                <MenuItem value='Product: Data Driven'>Product: Data Driven</MenuItem>
                                <MenuItem value='Product: User Focused'>Product: User Focused</MenuItem>
                                <MenuItem value='Question'>Question</MenuItem>
                                <MenuItem value='Suggestion'>Suggestion</MenuItem>
                                <MenuItem value='Feedback'>Feedback</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <TextField
                            name='description'
                            label='Description'
                            multiline
                            rows='4'
                            style={{ minWidth: '250px' }}
                            onChange={this.onChange}
                        />
                    </Grid>
                    <Grid item>
                        <Button type='submit' variant='contained' color='primary' onClick={this.handleSend} disabled={isInvalid}>
                            Send&nbsp;&nbsp;<SendIcon />
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )

        const sentConfirmation = (
            <Grid container spacing={24} direction='row'>
                <Grid item xs={12}>
                    <h1>send us a message</h1>
                </Grid>
                <Grid item xs={12}>
                    <Paper style={{ padding: '40px', backgroundColor: 'rgb(180, 255, 180)' }}>
                        Sent!
                    </Paper>
                </Grid>
            </Grid>
        )

        return (
            <div>
                <h1>Contact Us</h1>
                <Paper style={{ maxWidth: '500px', padding: window.innerWidth > 450 ? '20px 80px 40px 80px' : '20px', margin: '40px auto' }}>
                    {!this.state.sent ? contactUsForm : sentConfirmation}
                </Paper>
                {buttons}
            </div>
        )

    }

}

export default ContactUs
